
export class EnumHelper {
  /**
   * 由 enum 的值反查其鍵名（支援 number 與 string enum）。
   * 回傳找不到時為 undefined。
   */
  static key<
    E extends Record<string, string | number>,
    V extends E[keyof E]
  >(enm: E, value: V): Extract<keyof E, string> | undefined {
    // 對 number enum：TS 會產生雙向對應，可直接用反查表
    if (typeof value === "number" && Object.prototype.hasOwnProperty.call(enm, value)) {
        const k = (enm as unknown as Record<PropertyKey, unknown>)[value];
        if (typeof k === "string") return k as Extract<keyof E, string>;
    }

    // 對 string enum 或保險處理：掃描「非數字鍵」避免踩到 number enum 的反向鍵
    for (const k of Object.keys(enm)) {
        if (!Number.isNaN(Number(k))) continue; // 跳過 "0","1",... 這類反向鍵
        if ((enm as any)[k] === value) {
            return k as Extract<keyof E, string>;
        }
    }
    return undefined;
  }
}